module.exports = __webpack_public_path__ + "img/w4.4d3dd839.png";